import type { PbxLocationsLocale } from './en'

export const pbxLocationsEs = {
  header: `Ubicaciones`,
  headerSubtext: `Administra las ubicaciones de oficina en este PBX. Cada ubicación corresponde a un número telefónico E911 que se usará como identificador de llamada en llamadas de emergencia.`,
  addLocation: `Agregar Ubicación`,
  searchPlaceholder: `Buscar ubicaciones`,
  empty: `Aún no hay ubicaciones configuradas para este PBX.`,
  loadError: `Error al cargar las ubicaciones.`,
  column: {
    name: `Nombre`,
    extensionCount: `Extensiones`,
    e911Number: `Número E911`,
    e911Address: `Dirección E911`,
    actions: `Acciones`,
  },
  notConfigured: `Sin configurar`,
  notConfiguredE911Number: `Sin número E911 asignado`,
  notConfiguredE911Address: `Sin dirección E911 registrada`,
  edit: `Editar`,
  delete: `Eliminar`,
  extensionCountLabel_one: `{{count}} extensión`,
  extensionCountLabel_other: `{{count}} extensiones`,
  form: {
    createHeader: `Agregar Ubicación`,
    editHeader: `Editar Ubicación`,
    nameLabel: `Nombre`,
    namePlaceholder: `e.g. Main Office`,
    nameRequired: `El nombre es obligatorio`,
    phoneNumberLabel: `Número Telefónico E911`,
    phoneNumberPlaceholder: `Selecciona un número telefónico`,
    phoneNumberHelp: `La dirección E911 de este número se usará para las llamadas de emergencia realizadas desde esta ubicación.`,
    noAvailableNumbers: `No hay números telefónicos disponibles para asignar.`,
    loadingAvailableNumbers: `Cargando números disponibles...`,
    cancel: `Cancelar`,
    save: `Guardar`,
    create: `Crear Ubicación`,
    update: `Actualizar Ubicación`,
    createSuccess: `Ubicación creada.`,
    updateSuccess: `Ubicación actualizada.`,
    createError: `Error al crear la ubicación.`,
    updateError: `Error al actualizar la ubicación.`,
  },
  deleteModal: {
    header: `Eliminar Ubicación`,
    confirmMessage: `¿Estás seguro de que deseas eliminar "{{name}}"? Esta acción no se puede deshacer.`,
    reassignPrompt_one: `{{count}} extensión está asignada a esta ubicación y debe reasignarse antes de poder eliminarla. Elige una nueva ubicación:`,
    reassignPrompt_other: `{{count}} extensiones están asignadas a esta ubicación y deben reasignarse antes de poder eliminarla. Elige una nueva ubicación:`,
    reassignSelectPlaceholder: `Selecciona una ubicación de destino`,
    noOtherLocations: `No hay otras ubicaciones en este PBX. Crea otra ubicación primero.`,
    cancel: `Cancelar`,
    confirm: `Eliminar`,
    confirmReassign: `Reasignar y Eliminar`,
    success: `Ubicación eliminada.`,
    error: `Error al eliminar la ubicación.`,
  },
} satisfies PbxLocationsLocale
